export default [
  {
    title: 'Print Queue',
    route: 'print-queue-dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Printed',
    route: 'print-queue-printed',
    icon: 'HomeIcon',
    faIcon: 'fas fa-print',
  },
  {
    title: 'Post Replies',
    faIcon: 'fas fa-reply',
    userCheck: { type: 'repliesEnabled', value: true },
    route: {
      name: 'post-replies',
    },
  },
  {
    title: 'Reply Failures',
    faIcon: 'fas fa-exclamation-triangle',
    userCheck: { type: 'repliesEnabled', value: true },
    route: {
      name: 'post-replies-fail',
    },
  },
]
